import React from 'react';

export default function VisaIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={36}
      viewBox="0 0 60 36"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <rect width={59} height={35} x=".5" y=".5" stroke="#E6E6E6" rx={4} />
        <path
          fill="#26337A"
          d="M24.894 23.728l1.845-11.444h2.949l-1.845 11.444h-2.949M38.54 12.565a7.29 7.29 0 0 0-2.643-.48c-2.915 0-4.968 1.552-4.985 3.776-.018 1.645 1.465 2.563 2.583 3.11 1.15.56 1.535.919 1.53 1.42-.007.766-.917 1.117-1.764 1.117-1.181 0-1.808-.173-2.778-.6l-.38-.182-.412 2.562c.688.319 1.963.595 3.286.61 3.098 0 5.111-1.535 5.135-3.91.01-1.304-.775-2.293-2.477-3.109-1.03-.53-1.663-.882-1.656-1.42 0-.475.535-.984 1.69-.984a5.173 5.173 0 0 1 2.207.44l.264.13.4-2.48M42.466 19.67c.245-.657 1.175-3.198 1.175-3.198-.017.03.243-.663.392-1.092l.2.987s.565 2.731.682 3.304h-2.449zm3.638-7.375h-2.279c-.706 0-1.235.203-1.545.949L37.9 23.732h3.098s.505-1.41.62-1.72l3.777.005c.088.4.359 1.715.359 1.715h2.737l-2.387-11.437zM22.42 12.293l-2.886 7.803-.31-1.586c-.537-1.828-2.212-3.808-4.084-4.8l2.64 10.008 3.121-.002 4.644-11.423H22.42"
        />
        <path
          fill="#EC982D"
          d="M16.854 12.285H12.1l-.04.238c3.701.948 6.15 3.236 7.166 5.987L18.19 13.25c-.178-.725-.696-.94-1.337-.966"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/VisaIcon.svg.jsx